import {
    AFTER_WIDGET_CLICK,
    BUTTON_BACK,
    INACTIVITY_DELAY,
    NOT_SELECTED,
    OPEN_DELAY,
    PAGE_CLOSE,
    PAGE_OPEN,
    SCROLL_DOWN,
    SCROLL_UP,
    WIDGET_VISIBILITY_DELAY,
} from '../constants.js';

import { widgetTrigger } from './widgetTriggerEnum';
import { ActivityMonitor } from "./ActivityMonitor";

function handlerAfterWidgetClick(nodeId: string) {
    return new Promise(resolve => {
        if (!nodeId) {
            resolve('');
        }
        const widget = document.querySelector(`#${nodeId}`);
        widget.addEventListener('click', () => {
            resolve('');
        });
    });
}

function handlerButtonBack() {
    return new Promise(resolve => {
        /*history.pushState({}, '', '');*/
        window.addEventListener('popstate', () => {
            resolve('');
        })
    });
}

function handlerPageClose() {
    return new Promise(resolve => {
        document.body.addEventListener('mouseleave', (e) => {
            if (e.clientY <= 0) {
                resolve('');
            }
        });
    });
}

function handlerScrollUp(widgetToggleType: string){
    return new Promise(resolve => {
        // если тригер открытия и прокрутки нет (высота всего сайта = области просмотра) всегда показываем
        if (widgetToggleType === widgetTrigger.OPEN && window.innerHeight + window.scrollY >= document.body.scrollHeight) {
            resolve('');
            return;
        }
        // оставил одну проверку на оба тригера, вроде как смысла нет
        let timer: number;
        let scrollOffset = 0;
        timer = setInterval(() => {
            if (window.scrollY < scrollOffset) {
                clearInterval(timer);
                resolve('');
                return;
            }

            scrollOffset = window.scrollY <= 0 ? 0 : window.scrollY;
        }, 400);
    });
}

function handlerScrollDown(widgetToggleType: string) {
    return new Promise(resolve => {
        // если тригер открытия и прокрутки нет (высота всего сайта = области просмотра) всегда показываем
        if (widgetToggleType === widgetTrigger.OPEN && window.innerHeight + window.scrollY >= document.body.scrollHeight) {
            resolve('');
            return;
        }
        let timer: number;
        let scrollOffset = window.scrollY;
        timer = setInterval(() => {
            if (window.scrollY - scrollOffset > 0) {
                clearInterval(timer);
                resolve('');
                return;
            }
            scrollOffset = window.scrollY <= 0 ? 0 : window.scrollY;
        }, 400);
    });
}

function handlerInactivity(delaySecs: number, activityMonitor: ActivityMonitor) {
    return new Promise(resolve => {
        let timer: number;
        timer = setInterval(() => {
            const now = new Date().getTime();
            if (now - activityMonitor.lastActivity >= delaySecs * 1000) {
                clearInterval(timer);
                resolve('');
            }
        }, 1000);
    });
}

function handlerVisibilityDelay(delaySecs: number) {
    return new Promise(resolve => setTimeout(resolve, delaySecs * 1000, ''));
}

function handlerNotSelected(toggleType: string) {
    if (toggleType === widgetTrigger.CLOSE) {
        return new Promise(resolve => {
            // doing nothing
        });
    }
}

export const handlersTriggers = {
    [PAGE_OPEN]: () => new Promise(resolve => resolve('')),
    [OPEN_DELAY]: ({ trigger }) => handlerVisibilityDelay(trigger.delaySecs),
    [WIDGET_VISIBILITY_DELAY]: ({ trigger }) => handlerVisibilityDelay(trigger.delaySecs),
    [INACTIVITY_DELAY]: ({ trigger, activityMonitor }) => handlerInactivity(trigger.delaySecs, activityMonitor),
    [SCROLL_DOWN]: ({ toggleType }) => handlerScrollDown(toggleType),
    [SCROLL_UP]: ({ toggleType }) => handlerScrollUp(toggleType),
    [PAGE_CLOSE]: () => handlerPageClose(),
    [BUTTON_BACK]: () => handlerButtonBack(),
    [AFTER_WIDGET_CLICK]: ({ nodeId }) => handlerAfterWidgetClick(nodeId),
    [NOT_SELECTED]: ({ toggleType }) => handlerNotSelected(toggleType),
};